import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  IconButton,
  Link,
  makeStyles,
  CircularProgress,
} from "@material-ui/core";
import SendIcon from "@material-ui/icons/Send";
import CloseIcon from "@material-ui/icons/Close";
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import jwtDecode from "jwt-decode";
import AttachFileIcon from '@material-ui/icons/AttachFile';


import axios from "axios";
import moment from "moment";
// import { downloadCustomUploadedFile } from "../../../containers/actions/common/fileActions";

import { downloadCustomUploadedFile } from "../../../../../containers/actions/common/fileActions";
import { useDispatch, useSelector } from "react-redux";
// import { DESTROY_BACKDROP } from "../../../containers/actions/types";
import { DESTROY_BACKDROP } from "../../../../../containers/actions/types";
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import GetAppIcon from '@material-ui/icons/GetApp';
import { appUrl } from "../../../../../../../utils/config";

const useStyles = makeStyles((theme) => ({
  link: {
    color: 'blue',
    cursor: 'pointer',
    textDecoration: 'underline',
    padding: '5px 0px',
  },
}));

const ChatBox = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {batchDetails} = props;
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [error, setError] = useState("");
  const [newMessage, setNewMessage] = useState("");
  const tokenData = jwtDecode(localStorage.getItem("authToken"));
  const [file, setFile] = useState(null);
  const [fileURLs, setFileURLs] = useState({});
   const [chatData, setChatData] = useState(null);
  const chatContainerRef = useRef(null);
  const currentDate = new Date().toLocaleString();
  const [sendMessageLoading, setMessageLoading] = useState(false);
  
  // const schrockenDeliveryScheduleBatchID= useSelector(
    
  //     (state) =>
  //       state.pcmp.common.sasl.fetchAllBatches.data.deliveryScheduleBatches.schrockenDeliveryScheduleBatchID ||
  //       {}
  //   );
    // console.log("schrockenDeliveryScheduleBatchID", schrockenDeliveryScheduleBatchID)


   const scrollChatToBottom = () => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  };

 const handleSendMessage = async () => {
  if (newMessage.trim() !== "" || file) {
    // setLoading(true);
    setMessageLoading(true)
    // Generate object URL for the attached file
    // let fileURL = null;
    // if (file) {
    //   fileURL = URL.createObjectURL(file);
    //   setFileURLs((prevURLs) => ({
    //     ...prevURLs,
    //     [file.name]: fileURL,
    //   }));
    // }

    // setMessages([
    //   ...messages,
    //   {
    //     sender: tokenData.full_name,
    //     time: moment(currentDate, "M/D/YYYY, h:mm:ss A").format("MMM DD, YYYY HH:mm"),
    //     text: newMessage,
    //     type: "sent",
    //     file: file ? file.name : null,
    //     // fileURL: fileURL,
    //   },
    // ]);
    setNewMessage("");
    setFile(null);

    // Prepare FormData
    const formData = new FormData();
    formData.append("vendorBatchNumber", batchDetails?.vendorBatchNumber);
     formData.append("vendorMosymphonyID", batchDetails?.vendorMosymphonyID);
     formData.append("schrockenBatchID", batchDetails?.schrockenDeliveryScheduleBatchID,);
    formData.append("chatDataObject", JSON.stringify({
      chatSenderName: tokenData.full_name,
      chatSenderEmail: tokenData.email_address,
      chatTimestamp: new Date().toISOString(),
      chatData: newMessage.trim(),
      chatFileHash: file ? "notempty" : "",
      chatFileName: file ? file.name : "",
    }));
    formData.append("createdBy", tokenData.full_name);
    formData.append("lastUpdatedBy", tokenData.full_name);
    if (file) {
      formData.append("files", file); // Attach the file
    }

    try {
      // Send the form data using Axios
      const response = await axios.post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/addPOBatchItemChatData`,
        formData
      );

      if (response.data.status) {
        setError("");
        setTimeout(() => {
          let data = {
           // purchaseOrderNumber: poNumber,
           schrockenBatchID: batchDetails.schrockenDeliveryScheduleBatchID,
          };
      axios
          .post(
            `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPOBatchItemChatData`,
            data
          )
          .then((res) => {
            if (res.data.status && res.data.chatData) {
              
              setError("");
              // Transform API data into the format used in `messages`
              const formattedMessages = res.data.chatData.map((chat) => ({
                sender: chat.chatSenderName,
                time: moment(chat.chatTimestamp).format("DD-MMM-YYYY HH:mm").toUpperCase(),
                text: chat.chatData,
                type: chat.chatSenderEmail === tokenData.email_address ? "sent" : "received",
                file: chat.chatFileName || null,
                // fileURL: chat.chatFileHash ? `${appUrl}/files/${chat.chatFileHash}` : null,
                schrockenChatID:chat.schrockenChatID || null,
                chatFileHash:chat.chatFileHash || null,
              }));
      
              // Set the messages state with the fetched data
              // setMessages(formattedMessages);
              // setLoading(false);
              setMessageLoading(false)
              setTimeout(() => {
                setMessages(formattedMessages);
                scrollChatToBottom();
              }, 200);
            } else {
              // setLoading(false);
            setMessageLoading(false)
            setError("Something went wrong. Please try again.");
            }
          })
          .catch((err) => {
            // setLoading(false);
            setMessageLoading(false)
            setError("Something went wrong. Please try again.");
            console.log(err);
            // setStatus(false);
          })
        },1000)
        // console.log("Chat data successfully sent!");
          
      }
    } catch (error) {
      // setLoading(false)
      setMessageLoading(false)
      console.error("Error sending chat data:", error);
      setError("Something went wrong. Please try again.");
    }

  }
};

const handleFileUpload = (event) => {
  
    const file = event.target.files[0];
    if (file) {
      setFile(file); // Store the file in state
      console.log("Uploaded file:", file);
    }
  //   if (file) {
  //     // const fileURL = URL.createObjectURL(file);
  //     setFile(file);
  //     setFileURLs((prevURLs) => ({
  //       ...prevURLs,
  //       [file.name]: fileURL,
  //     }));
  // };
  
}


useEffect(() => {
  if (isOpen && batchDetails?.vendorBatchNumber) {
    setLoading(true);
let data = {
      //purchaseOrderNumber: poNumber,
      schrockenBatchID: batchDetails.schrockenDeliveryScheduleBatchID,
    };
axios
    .post(
      `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPOBatchItemChatData`,
      data
    )
    // .then((res) => {
    //   if (res.data.status) {
    //     setChatData(res.data.chatData);
    //   }
    // })
    .then((res) => {
      if (res.data.status && res.data.chatData) {
        setLoading(false);
        setError("");
        // Transform API data into the format used in `messages`
        const formattedMessages = res.data.chatData.map((chat) => ({
          sender: chat.chatSenderName,
          time: moment(chat.chatTimestamp).format("DD-MMM-YYYY HH:mm").toUpperCase(),
          text: chat.chatData,
          type: chat.chatSenderEmail === tokenData.email_address ? "sent" : "received",
          file: chat.chatFileName || null,
          // fileURL: chat.chatFileHash ? `${appUrl}/files/${chat.chatFileHash}` : null,
          schrockenChatID:chat.schrockenChatID || null,
          chatFileHash:chat.chatFileHash || null,
        }));

        // Set the messages state with the fetched data
        setMessages(formattedMessages);
        setTimeout(() => {
          scrollChatToBottom();
        }, 100);
      }
    })
    .catch((err) => {
      setLoading(false);
      console.log(err)
      setError("Something went wrong. Please try again.");
    })
} 
}, [batchDetails?.vendorBatchNumber,isOpen]);

const handleDownloadFile = (schrockenChatID) =>{
  let data = {
    docType : "chat",
    schrockenChatID,
  };
  //console.log(data)
  setLoading(true);
  axios
    .post(
      `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/downloadChatFile`,
      data
    )
    .then((res) => {
       if (res.data.status) {
              let fileDataArray = res.data.fileData.data;
              var byteArray = new Uint8Array(fileDataArray);
      
              var a = window.document.createElement('a');
      
              a.href = window.URL.createObjectURL(
                new Blob([byteArray], { type: 'application/octet-stream' })
              );
              a.download = res.data.fileName;
      
              document.body.appendChild(a);
              a.click();
         document.body.removeChild(a);
         setLoading(false);
         setTimeout(() => {
          scrollChatToBottom();
        }, 100);
       } else {
         setLoading(false);
         setTimeout(() => {
          scrollChatToBottom();
        }, 100);
}
    })
    .catch((err) => {
      console.log(err)
      setLoading(false);
      setTimeout(() => {
        scrollChatToBottom();
      }, 100);
    });
}


  return (
    <>
    <Box
      position="fixed"
      bottom="0"
      right="20px"
      width="auto"
      boxShadow={3}
      borderRadius={isOpen ? "10px" : "20px 20px 0 0"}
      overflow="hidden"
      bgcolor="white"
      style={{ zIndex: 1300 }}
    >
      {/* Chat Bar */}
      {!isOpen && (
        <Box
          bgcolor="#2196f3"
          color="white"
          padding="10px"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          onClick={() => setIsOpen(true)}
          style={{ cursor: "pointer" }}
        >
          <Typography variant="subtitle1" style={{ fontSize: "1rem" }}>
          Comment section for Batch {batchDetails?.vendorBatchNumber} (Quality events)
          </Typography>
          <IconButton
              size="small"
              style={{ color: "white" }}
              // onClick={() => setIsOpen(false)}
            >
              <KeyboardArrowUpIcon />
            </IconButton>
        </Box>
      )}

      {/* Full Chat Box */}
      {isOpen && (
        <Box display="flex" flexDirection="column" height="400px" >
          {/* Chat Header */}
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            bgcolor="#2196f3"
            color="white"
            padding="10px"
              borderRadius="10px 10px 0 0"
              style={{ cursor: "pointer" }} onClick={() => setIsOpen(false)}
          >
            <Typography variant="h6" style={{ fontSize: "1rem" }}>
            Comment section for Batch {batchDetails?.vendorBatchNumber} (Quality events)
            </Typography>
            <IconButton
              size="small"
              style={{ color: "white" }}
              onClick={() => setIsOpen(false)}
            >
              {/* <CloseIcon /> */}
              <KeyboardArrowDownIcon />
            </IconButton>
          </Box>

          {/* Chat Messages */}
          <Box flexGrow="1" padding="10px" overflow="auto" bgcolor="#e7ecee" ref={chatContainerRef}>
            {loading ? (
              <div style={{ display:'flex',alignItems:'center',justifyContent:'center',marginTop:'5rem' }}>
           <CircularProgress color='primary' thickness={7} />
          </div>
            ) : error ? (
              <div           
              style={{
                border: '2px solid rgb(255,0,0)',
                backgroundColor: 'rgb(255,240,240)',
                Opacity: 1,
                textAlign: 'center',
                padding: '0.8rem',
                fontSize: '0.875rem',
                marginTop:'4rem',
              }}>
              <Typography color="error" style={{ textAlign: "center", margin: "10px 0" }}>
                {error}
              </Typography>
              </div>
          ) : (
                    messages.map((msg, index) => (
                       <Box
                         key={index}
                         display="flex"
                         flexDirection="column"
                         alignItems={msg.type === "sent" ? "flex-end" : "flex-start"}
                         marginBottom="15px"
                       >
                         <Box
                           bgcolor={msg.type === "sent" ? "#dcf8c6" : "#ffffff"}
                           color="black"
                           padding="10px"
                           borderRadius="15px"
                           maxWidth="80%"
                           boxShadow="0px 4px 6px rgba(0, 0, 0, 0.1)"
                          // boxShadow={1}
                          style={{
                             alignSelf: msg.type === "sent" ? "flex-end" : "flex-start",
                             marginLeft: msg.type === "received" ? "10px" : "auto",
                             marginRight: msg.type === "sent" ? "10px" : "auto",
                          }}
                        >
                          <Typography
                            variant="body2"
                            style={{ fontWeight: "bold",
                              color: msg.type === "sent" ? "#ef7b52" : "green"
                             }}
                          >
                            {msg.sender}
                           </Typography>
                          <Typography
                            variant="caption"
                            style={{
                              color: "#929292",
                              textAlign: "left",
                              fontSize: "0.75rem",
                            }}
                          >
                            {msg.time}
                          </Typography>
                          <Typography variant="body2" style={{ marginBottom: "5px" }}>
                            {msg.text}
                          </Typography>
                          {msg.file && (
                            <Typography
                      variant={'body2'}
                      className={classes.link}
                      style={{
                        textDecoration: 'underline',
                        display:'flex',
                         }}
                         onClick={() =>handleDownloadFile(msg.schrockenChatID)}
                            >
                              <GetAppIcon fontSize='small' style={{color:'blue'}} />
                                              {msg.file}
                                              {/* {loading && (
                                                <CircularProgress
                                                  size={14}
                                                  style={{
                                                    marginLeft: 8, // Add spacing between the file name and spinner
                                                  }}
                                                  />
                                                )} */}
                                                      </Typography>
                                                            )}
                                                          </Box>
                                                        </Box>
                                                      ))
                                        )}

          </Box>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="flex-start"
            padding="10px"
            borderTop="1px solid #ddd"
          >
            {/* File Preview */}
            {file && (
              <Box
                display="flex"
                alignItems="center"
                bgcolor="#f1f1f1"
                padding="5px"
                borderRadius="5px"
                marginBottom="5px"
                width="100%"
              >
                <Typography variant="body2" style={{ marginRight: "10px" }}>
                  {file.name}
                </Typography>
                <IconButton size="small" onClick={() => setFile(null)}>
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Box>
            )}

          {/* Chat Input */}
          <Box
            display="flex"
            alignItems="center"
            padding="10px"
            border="1px solid black"
            width="95%"
          >
                  <IconButton color="primary" component="label">
        <AttachFileIcon style={{color:'black'}} />
        {/* Hidden input for file upload */}
        <input
          type="file"
          hidden
          onChange={handleFileUpload}
                    accept=".csv,.xls,.xlsx,.pdf,.jpeg,.png,.jpg,.bmp,.doc,.docx"
        />
      </IconButton>
            <TextField
              placeholder="Type your comment here..."
              variant="outlined"
              size="small"
              fullWidth
              value={newMessage}
              onChange={(e) => {
                if(e.target.value.length < 256){
                  setNewMessage(e.target.value)
              }
            }}
              onBlur={(e) => {
                const { value } = e.target;
                // Trim leading and trailing spaces for string values
                if (typeof value === "string" && value.trim() !== value) {
                  setNewMessage(value.trim());
                }
              }}
              onKeyPress={(e) => {
                          const {  value } = e.target;
                          if(e.key === "Enter"){
                            setNewMessage(value.trim());
                            handleSendMessage()
                          }
                        }}
                />
                {sendMessageLoading ? 
                  <IconButton
                  style={{ marginLeft: "10px" }}
                >
                    <CircularProgress color='primary' size={'25px'} thickness={3} />
                    </IconButton>
                  :
<IconButton
              color="primary"
              onClick={handleSendMessage}
              style={{ marginLeft: "10px" }}
            >
              <SendIcon />
            </IconButton>
                }
            
          </Box>
          </Box>
        </Box>
      )}
    </Box>
    </>
  );
};

export default ChatBox;


